import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { Organization, OrganizationsService } from "@kno2/data-access/organizations";

export const organizationResolver: ResolveFn<Organization> = async (route) => {
    const organizationsService = inject(OrganizationsService);
    const organizationId = route.paramMap.get("id");

    const organization = await organizationsService.getOrganizationAsync(organizationId, { reload: true });
    return organization;
};
